import { h as o } from "vue";
import i from "./design-system.es288.js";
import s from "./design-system.es289.js";
import { useListContext as f } from "./design-system.es34.js";
import { useConfig as p } from "./design-system.es28.js";
const l = {
  name: "DsListItem",
  props: {
    /**
     * Enables the next variant of the ListItem component.
     */
    next: {
      type: Boolean,
      default: !1
    }
  },
  setup(r, { attrs: t, slots: e }) {
    const m = f(), n = p();
    return () => m || r.next || n.listItemNext ? o(s, t, e) : o(i, t, e);
  }
};
export {
  l as default
};
//# sourceMappingURL=design-system.es67.js.map
